<div class="step-progress">
  @for (step of steps; track step; let i = $index) {
    <span class="step" [ngClass]="i+1 <= stepProgress ? progressClasses : 'base'"></span>
  }
</div>